export default __webpack_public_path__ + "static/2293-a2b8463a861d922aa0a11194b48397f9.gif";